import { makeRoute } from "@/lib/makeRoute";
export const Route = makeRoute("/faq", "fr", "faq");
